<template>
  <div id="app">
    <SiteHeader />
    <main class="app-main">
      <router-view />
    </main>
    <FloatingContact />
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "./components/layout/SiteHeader.vue";
import SiteFooter from "./components/layout/SiteFooter.vue";
import FloatingContact from "./components/layout/FloatingContact.vue";

export default {
  name: "App",
  components: {
    SiteHeader,
    SiteFooter,
    FloatingContact
  }
};
</script>

<style scoped>
.app-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
